export default __webpack_public_path__ + "static/media/portfolio.4d463f43.png";